import React, { useEffect, useMemo, useState } from "react";
import "./Clientes.css";
import "../styles/theme-dark.css"; // IMPORTANTE

const API = "/api";


// normaliza texto (quita acentos y pasa a minúsculas)
const norm = (s = "") =>
  (s + "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export default function Clientes() {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);

  // búsqueda
  const [query, setQuery] = useState("");

  // modal crear/editar
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const isEditing = editingId !== null;

  const emptyForm = {
    nombre_empresa: "",
    nif: "",
    direccion: "",
    telefono: "",
    email: "",
    pais: "España",
    tipo_iva: "21% (España)",
    direccion_fiscal: "",
    direccion_entrega: "",
    entrega_igual_fiscal: false,
    nombre_contacto: "",

  };
  const [form, setForm] = useState(emptyForm);

  // Cargar clientes
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/clientes`);

        const json = await res.json();
        setClientes(json.data || []);
      } catch (e) {
        console.error("Error cargando clientes", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // sincroniza entrega == fiscal
  useEffect(() => {
    if (form.entrega_igual_fiscal) {
      setForm((prev) => ({
        ...prev,
        direccion_entrega: prev.direccion_fiscal,
      }));
    }
  }, [form.entrega_igual_fiscal, form.direccion_fiscal]);

  // Abrir modal en modo NUEVO
  const openCreate = () => {
    setEditingId(null);
    setForm(emptyForm);
    setShowModal(true);
  };

  // Abrir modal en modo EDITAR
  const openEdit = (c) => {
    setEditingId(c.id);
    setForm({
  ...emptyForm,
  ...c,

  // 🔑 MAPEO CORRECTO BACKEND → FRONTEND
  nombre_contacto: c.personaContacto || "",

  entrega_igual_fiscal:
    !!c.direccion_fiscal &&
    c.direccion_fiscal === (c.direccion_entrega || ""),
});

    setShowModal(true);
  };

  const closeModal = () => {
    if (!saving) {
      setShowModal(false);
      setEditingId(null);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const method = isEditing ? "PUT" : "POST";
      const url = isEditing
  ? `${API}/clientes/${editingId}`
  : `${API}/clientes`;


      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const json = await res.json().catch(() => ({ success: false }));
      if (json?.success) {
        if (isEditing) {
          setClientes((prev) =>
            prev.map((c) =>
              String(c.id) === String(editingId) ? json.data : c
            )
          );
        } else {
          setClientes((prev) => [json.data, ...prev]);
        }
        setShowModal(false);
        setEditingId(null);
      } else {
        alert("No se pudo guardar el cliente");
      }
    } catch (err) {
      console.error(err);
      alert("Error guardando el cliente");
    } finally {
      setSaving(false);
    }
  };

  // Eliminar cliente
  const removeCliente = async (id) => {
    if (!window.confirm("¿Eliminar este cliente?")) return;
    try {
      const res = await fetch(`${API}/clientes/${id}`, {

        method: "DELETE",
      });
      const json = await res.json().catch(() => ({ success: false }));
      if (json?.success) {
        setClientes((prev) =>
          prev.filter((c) => String(c.id) !== String(id))
        );
      } else {
        alert("No se pudo eliminar el cliente");
      }
    } catch (e) {
      console.error(e);
      alert("Error eliminando el cliente");
    }
  };

  // FILTRO
  const filtered = useMemo(() => {
    if (!query.trim()) return clientes;
    const q = norm(query);
    return clientes.filter((c) => {
      return (
        norm(c.nombre_empresa).includes(q) ||
        norm(c.nif).includes(q) ||
        norm(c.telefono || "").includes(q) ||
        norm(c.email || "").includes(q) ||
        norm(c.pais || "").includes(q) ||
        norm(c.tipo_iva || "").includes(q)
      );
    });
  }, [clientes, query]);

  /* ============================================================
        🎨 UI DARK + GLASS — APLICADO AQUÍ
  ============================================================ */

  return (
    <div className="page-dark">

      {/* HEADER DARK GLASS */}
      <header
        style={{
          padding: "20px 30px",
          marginBottom: 25,
          background: "rgba(15,23,42,0.65)",
          borderBottom: "1px solid rgba(255,255,255,0.12)",
          backdropFilter: "blur(10px)",
          borderRadius: "0 0 16px 16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.45)"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <img src="/corex-logo.png" alt="COREX" style={{ height: 40 }} />
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>
              Clientes
            </h1>
          </div>

          <button
            className="glass-btn"
            onClick={() => window.history.back()}
            style={{ fontSize: 14 }}
          >
            ← Volver
          </button>
        </div>

        <p style={{ opacity: 0.7, marginTop: 6 }}>
          Gestiona tus clientes registrados.
        </p>
      </header>

      {/* BARRA BUSCAR + NUEVO */}
      <div
        className="glass-box"
        style={{
          marginBottom: 18,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 14,
        }}
      >
        <div style={{ flex: 1 }}>
          <input
            className="glass-input"
            type="search"
            placeholder="Buscar cliente por nombre, NIF, email…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div style={{ fontSize: 12, marginTop: 4, opacity: 0.6 }}>
            Total: <strong>{clientes.length}</strong> — Coincidencias:{" "}
            <strong>{filtered.length}</strong>
          </div>
        </div>

        <button className="glass-btn" onClick={openCreate}>
          + Nuevo Cliente
        </button>
      </div>

      {/* LISTA DE CLIENTES */}
      <div className="glass-box">
        {loading ? (
          <div>Cargando…</div>
        ) : (
          <table className="glass-table">
            <thead>
              <tr>
                <th>Empresa</th>
                <th>NIF</th>
                <th>Teléfono</th>
                <th>Email</th>
                <th>País</th>
                <th>Tipo IVA</th>
                <th style={{ textAlign: "right" }}>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((c) => (
                <tr key={c.id}>
                  <td><strong>{c.nombre_empresa}</strong></td>
                  <td>{c.nif}</td>
                  <td>{c.telefono || "-"}</td>
                  <td>{c.email || "-"}</td>
                  <td>{c.pais || "-"}</td>
                  <td>{c.tipo_iva || "-"}</td>
                  <td style={{ textAlign: "right" }}>
                    <button className="glass-btn" onClick={() => openEdit(c)}>
                      Editar
                    </button>

                    <button
                      className="glass-btn"
                      style={{ marginLeft: 8, background: "rgba(255,0,0,0.25)" }}
                      onClick={() => removeCliente(c.id)}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}

              {filtered.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center", opacity: 0.5 }}>
                    Sin resultados para “{query}”
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

     {/* MODAL */}
{showModal && (
  <div className="modal-overlay">
    <div className="modal modal--wide glass-box">
      <div
        className="modal-header"
        style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}
      >
        <h3 style={{ margin: 0 }}>
          {isEditing ? "Editar Cliente" : "Nuevo Cliente"}
        </h3>
        <button className="glass-btn" onClick={closeModal}>
          ✕
        </button>
      </div>

      <form onSubmit={handleSubmit} className="modal-body form-grid">
        {/* DATOS PRINCIPALES */}
        <div className="grid-2">
          <div className="field">
            <label>Nombre Empresa *</label>
            <input
              className="glass-input"
              name="nombre_empresa"
              value={form.nombre_empresa}
              onChange={handleChange}
              required
            />
          </div>

          <div className="field">
            <label>NIF/CIF *</label>
            <input
              className="glass-input"
              name="nif"
              value={form.nif}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="field">
          <label>Dirección (general)</label>
          <textarea
            className="glass-input"
            name="direccion"
            value={form.direccion}
            onChange={handleChange}
            rows={2}
          />
        </div>

        {/* CONTACTO */}
        <div className="grid-3">
          <div className="field">
            <label>Teléfono</label>
            <input
              className="glass-input"
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Email</label>
            <input
              type="email"
              className="glass-input"
              name="email"
              value={form.email}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Nombre de contacto</label>
            <input
              className="glass-input"
              name="nombre_contacto"
              value={form.nombre_contacto}
              onChange={handleChange}
              placeholder="Persona de contacto"
            />
          </div>
        </div>

        {/* PAÍS / IVA */}
        <div className="grid-2">
          <div className="field">
            <label>País</label>
            <select
              className="glass-input"
              name="pais"
              value={form.pais}
              onChange={handleChange}
            >
              <option>España</option>
              <option>Portugal</option>
              <option>Canarias</option>
              <option>Otro</option>
            </select>
          </div>

          <div className="field">
            <label>Tipo IVA</label>
            <select
              className="glass-input"
              name="tipo_iva"
              value={form.tipo_iva}
              onChange={handleChange}
            >
              <option>21% (España)</option>
              <option>0% (Portugal – Exento)</option>
              <option>0% (Canarias – IGIC)</option>
              <option>Personalizado</option>
            </select>
          </div>
        </div>

        {/* DIRECCIONES */}
        <div className="section-head" style={{ marginTop: 10 }}>
          <div className="section-title">Direcciones</div>
          <label className="checkbox-inline">
            <input
              type="checkbox"
              name="entrega_igual_fiscal"
              checked={form.entrega_igual_fiscal}
              onChange={handleChange}
            />
            Usar dirección fiscal como entrega
          </label>
        </div>

        <div className="grid-2">
          <div className="field">
            <label>Dirección fiscal</label>
            <textarea
              className="glass-input"
              name="direccion_fiscal"
              value={form.direccion_fiscal}
              onChange={handleChange}
              rows={3}
            />
          </div>

          <div className="field">
            <label>Dirección de entrega</label>
            <textarea
              className="glass-input"
              name="direccion_entrega"
              value={form.direccion_entrega}
              onChange={handleChange}
              rows={3}
              disabled={form.entrega_igual_fiscal}
            />
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer" style={{ marginTop: 15 }}>
          <button
            type="button"
            className="glass-btn"
            onClick={closeModal}
          >
            Cancelar
          </button>

          <button type="submit" className="glass-btn" disabled={saving}>
            {saving
              ? "Guardando…"
              : isEditing
              ? "Guardar cambios"
              : "Guardar Cliente"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}


    </div>
  );
}
